import React, { forwardRef } from 'react';
import { AccentButtonProps } from './types';
import PrimaryButton from '../PrimaryButton';

const AccentButton = forwardRef<any, AccentButtonProps>((props, ref) => (
  <PrimaryButton accent ref={ref} {...props} />
));

export default AccentButton;
